import { render } from "./HeroiconsOutlineVolumeUp.vue?vue&type=template&id=ba67400e"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVolumeUp.vue"]])

export default __exports__